import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import {
    hideModal,
    showModal,
    lossOfWorkRunQueuedAction,
    lossOfWorkRunCanceledQueuedAction,
} from "../../../actions/actionCreators";
import { requestLayoutList } from "../../../actions/exportLayoutActions2";
import { requestFlow, flowRemoveUnsavedItems, requestFlowSave } from "../../../actions/flowActions";
import MaterialModal from "../MaterialModal";
import Button from "@material-ui/core/Button";

import { requestFlowSaveObject } from "../../../helpers/flowSaveObject";

const LossOfWork = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();
    const selectedFlowId = useSelector(state => state.selected.flow);
    const userId = useSelector(state => state.session.userId);
    const hide = () => {
        dispatch(hideModal("LOSS_OF_WORK"));
        dispatch(lossOfWorkRunCanceledQueuedAction());
    };

    const runQueuedAction = () => {
        const type = getType();

        dispatch(hideModal("LOSS_OF_WORK"));

        if (type == "layout") {
            dispatch(requestLayoutList("overwrite")); // Wipe out any unsaved changes
        } else if (type == "flow") {
            dispatch(flowRemoveUnsavedItems());
            dispatch(requestFlow(selectedFlowId, "merge-overwrite"));
        }

        dispatch(lossOfWorkRunQueuedAction());
    };

    const save = () => {
        const type = getType();

        dispatch(hideModal("LOSS_OF_WORK"));
        if (type != "layout") {
            dispatch(lossOfWorkRunCanceledQueuedAction());
        }
        if (type == "flow") {
            const params = requestFlowSaveObject();
            dispatch(requestFlowSave(params));
        }
    };

    const saveAs = () => {
        const type = getType();

        dispatch(hideModal("LOSS_OF_WORK"));
        dispatch(lossOfWorkRunCanceledQueuedAction());

        if (type == "flow") {
            dispatch(showModal("SAVE_FLOW", { saveAs: true }));
        }
    };

    const getType = () => {
        if (modalProps && modalProps.layout) {
            return "layout";
        }
        if (modalProps && modalProps.flow) {
            return "flow";
        }
        return null;
    };

    const renderModal = () => {
        const type = getType();
        const undefinedTypeVar = type === "layout" || type === "flow" ? false : true;
        const typeString = type != null ? "to this " + type : "";
        const typeAction = type != "layout" ? "save? " : "go back?";
        let saveString = "Looks like you're in the middle of making changes " + typeString;
        if (undefinedTypeVar) {
            saveString += "\nand haven't saved yet. Do you want to discard or go back?";
        } else {
            saveString += "\nand haven't saved yet. Do you want to discard or " + typeAction;
        }

        const isLockedFlow =
            type == "flow" && modalProps != null && modalProps.flow != null && modalProps.flow.IsLocked;
        let flowCreatedBy =
            type == "flow" && modalProps != null && modalProps.flow != null ? modalProps.flow.FlowCreatedBy : "";
        let showButton = type != "flow" || (flowCreatedBy != "" && flowCreatedBy == userId);
        flowCreatedBy != "" && flowCreatedBy != userId
            ? (saveString =
                  "Looks like you're in the middle of making changes to another individual's flow.  \nWould you like to save the changes to your library?")
            : "";
        const materialFooter = (
            <div>
                {!isLockedFlow && showButton && (
                    <Button variant="contained" color="primary" onClick={save} style={{ margin: "3px" }}>
                        {type == "layout" || undefinedTypeVar ? "Go Back" : "Save"}
                    </Button>
                )}
                {type == "flow" && (
                    <Button variant="contained" color="primary" onClick={saveAs} style={{ margin: "3px" }}>
                        Save As
                    </Button>
                )}
                <Button variant="contained" color="secondary" onClick={runQueuedAction} style={{ margin: "3px" }}>
                    Discard Changes
                </Button>
            </div>
        );

        return (
            <MaterialModal
                title="Loss of Work Warning!"
                isOpen={isOpen}
                onClose={hide}
                id="Loss-Of-Work"
                maxWidth="lg"
                showPrimaryButton={false}
                footer={materialFooter}
            >
                <div style={{ whiteSpace: "pre-wrap" }}>{saveString}</div>
            </MaterialModal>
        );
    };
    return renderModal();
};

LossOfWork.propTypes = {
    // Injected from Redux
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
    showModal: PropTypes.func,
    lossOfWorkRunQueuedAction: PropTypes.func,
    lossOfWorkRunCanceledQueuedAction: PropTypes.func,
    requestLayoutList: PropTypes.func,
    requestFlows: PropTypes.func,
    flowRemoveUnsavedItems: PropTypes.func,
    requestFlowSave: PropTypes.func,
};

import withModal from "../withModal";
export default withModal(LossOfWork, "LOSS_OF_WORK");
